import { cssVar, mediaQuery } from 'src/app/styles/helper';
import styled, { css } from 'styled-components';

// Used to define the aspect ratio of the absolute size element
export const PlaceholderContainer = styled.div`
  width: 100%;
  height: 100%;
  opacity: 0;
  pointer-events: none;
  z-index: -1;
  position: relative;

  ${mediaQuery(
    'sm',
    css`
      min-width: 160%;
    `
  )}
`;

interface TabbedFeaturesAssetCarouselContainerProps {
  $columns: number;
}

export const SPACING_GAP_VARIABLE = 'spacing-xl';

export const TabbedFeaturesAssetCarouselContainer = styled.div<TabbedFeaturesAssetCarouselContainerProps>`
  display: grid;
  grid-template-columns: repeat(${({ $columns }) => $columns}, 100%);
  max-width: 100%;
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  height: 100%;
  gap: ${cssVar(SPACING_GAP_VARIABLE)};

  .tabbed-feature-asset {
    scale: 0.95;
    opacity: 0.6;
    box-shadow: ${cssVar('shadow-lg')};
    transition:
      scale 0.5s ease-in-out,
      opacity 0.5s ease-in-out;

    &.active {
      scale: 1;
      opacity: 1;
    }
  }

  ${({ $columns }) => css`
    ${mediaQuery(
      'sm',
      css`
        grid-template-columns: repeat(${$columns}, 160%);

        .tabbed-feature-asset {
          height: fit-content;
          border-radius: ${cssVar('radius-md')};
        }
      `
    )}
  `}
`;
